import api from '../api';

export function listIntegrations(accountId) {
    return api.get(`/integrations?account_id=${accountId}`).then(response => response.data);
}

export function removeIntegration(integrationId) {
    return api.delete(`/integrations/${integrationId}`);
}
